import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Log, LogFilter } from '../shared/log';
import { RootState } from './store';
import { Status } from '../shared/common';

// Define a type for the slice state
export interface LogState {
    filter?: LogFilter,
    logs: Log[],
    totalLog: number,
    status: Status,
    error: string | null
}

// Define the initial state using that type
const initialState: LogState = {
    logs: [],
    totalLog: 0,
    status: "idle",
    error: null
}

export const logSlice = createSlice({
    name: "log",
    initialState: initialState,
    reducers: {
        getlogs: (state: LogState, action: PayloadAction<{data: Log[],total: number}>) => {           
            return { ...state, logs: action.payload.data, totalLog: action.payload.total };
        }
    },
    extraReducers: (builder) => {

    }
});

// this is for dispatch
export const { getlogs } = logSlice.actions;
// Other code such as selectors can use the imported `RootState` type
export const selectLogs = (state: RootState) => state.log.logs
export const selectLogById = (state: RootState, logId: string) => state.log.logs.find(x => x.id === logId)

// this is for configureStore
export default logSlice.reducer;


